import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FreeDelivery from "../../../../../../assets/images/hardware-inclusive/free-delivery-white.svg";
import AutomatedSupply from "../../../../../../assets/images/hardware-inclusive/automated-supply-white.svg";
import './HardwareSignupHeader.css'
function HardwareSignupHeader() {
  const { t } = useTranslation(['translation'])
  const [activeIndex, setActiveIndex] = useState(0);

  const features = [
    t("HARDWARE_SIGNUP.HEADER.FREE_DELIVERY"),
    t("HARDWARE_SIGNUP.HEADER.AUTOMATED_SUPPLY")
  ];

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? features.length - 1 : prev - 1
    );
  };

  return (
    <div className='hardware-header'>
      <div className="hardware-header__content">
        <div className='hardware-header__title'>{t("HARDWARE_SIGNUP.HEADER.SUBSCRIPTION_PERSONALISED")}</div>
        <div className='hardware-header__subtitle'>{t("HARDWARE_SIGNUP.HEADER.GET_INK_TONER_CARTRIDGE")}</div>
      </div>
      <div className="hardware-header__features">
        <div className='desktop-features'>
          <div className="hardware-header__feature">
            <img
              src={FreeDelivery}
              alt=""
              className="hardware-header__feature-icon"
            />
            <div className="hardware-header__feature-text">
              {t("HARDWARE_SIGNUP.HEADER.FREE_DELIVERY")}
            </div>
          </div>
          <div className="hardware-header__feature">
            <img
              src={AutomatedSupply}
              alt=""
              className="hardware-header__feature-icon"
            />
            <div className="hardware-header__feature-text">
              {t("HARDWARE_SIGNUP.HEADER.AUTOMATED_SUPPLY")}
            </div>
          </div>
        </div>
        <div className="mobile-carousel">
          <button onClick={prevSlide} className="carousel-arrow">‹</button>
          <div className="carousel-text">
            {features[activeIndex]}
          </div>
          <button onClick={nextSlide} className="carousel-arrow">›</button>
        </div>
      </div>
    </div>
  )
}

export default HardwareSignupHeader